// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__o0bmL","notes":"Notes_notes__1hMLb","note":"Notes_note__2uckJ","markdown":"Notes_markdown__3Hk7W"};